import i18n from './index';
import sourceKeys from './sourceKeys.json';
import { getLanguageLocale } from './language';

// Legacy labels remain canonical in state and payloads. Resolve their catalog
// keys at presentation time so notifications and metadata follow language changes.
const keys = new Map(Object.entries(sourceKeys));
const foldedKeys = new Map([...keys].map(([source, key]) => [source.toLocaleLowerCase('pt-BR'), key]));
const patterns = [...keys].filter(([source]) => source.includes('{{')).map(([source, key]) => {
  const names = [];
  const parts = source.split(/(\{\{\w+\}\})/g).map((part) => {
    if (part.startsWith('{{')) { names.push(part.slice(2, -2)); return '(.+?)'; }
    return part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  });
  return { key, names, regex: new RegExp(`^${parts.join('')}$`) };
});

export const getLocale = (language = i18n.resolvedLanguage || i18n.language) => getLanguageLocale(language);

export const tr = (source, values = {}, language) => {
  if (typeof source !== 'string') return source;
  const normalized = source.replace(/\s+/g, ' ').trim();
  const options = { ns: 'app', ...(language ? { lng: language } : {}) };
  const translatedValues = Object.fromEntries(Object.entries(values).map(([key, value]) => [key, typeof value === 'string' ? tr(value, {}, language) : value]));
  const key = keys.get(normalized);
  if (key) return i18n.t(key, { ...options, ...translatedValues });
  const folded = foldedKeys.get(normalized.toLocaleLowerCase('pt-BR'));
  if (folded) {
    const value = i18n.t(folded, { ...options, ...translatedValues });
    return normalized[0] === normalized[0].toLowerCase() ? value[0].toLowerCase() + value.slice(1) : value;
  }
  for (const pattern of patterns) {
    const match = normalized.match(pattern.regex);
    if (match) return i18n.t(pattern.key, { ...options, ...Object.fromEntries(pattern.names.map((name, index) => [name, tr(match[index + 1], {}, language)])) });
  }
  return source;
};
